import React, { useState, useRef, useEffect } from 'react';
import { verifyPin } from '@/services/api.js';
import { saveToken, logout } from '@/services/auth.js';

const PinVerification = ({ uuid, userName, onSuccess }) => {
    const [digits, setDigits] = useState(['', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const inputRefs = [useRef(), useRef(), useRef(), useRef()];

    useEffect(() => { inputRefs[0].current?.focus(); }, []);

    const handleInputChange = (index, value) => {
        if (!/^[0-9]$/.test(value) && value !== '') return;

        const newDigits = [...digits];
        newDigits[index] = value;
        setDigits(newDigits);

        if (value && index < 3) inputRefs[index + 1].current.focus();
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && !digits[index] && index > 0) {
            inputRefs[index - 1].current.focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text').trim();
        if (/^\d{4}$/.test(pasteData)) {
            setDigits(pasteData.split(''));
            inputRefs[3].current.focus();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const pin = digits.join('');
        if (pin.length !== 4) {
            setError('Please enter a 4-digit PIN');
            return;
        }

        setLoading(true);
        setError('');
        logout();

        try {
            const response = await verifyPin(uuid, pin);

            if (response.result) {
                saveToken(response.data.token, uuid);
                onSuccess();
            } else {
                setError('Invalid PIN. Please try again.');
            }
        } catch (err) {
            console.log(err)
            setError('Verification failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="pin-verification-container">
            <h2 className="text-center mb-2">Hi {userName || 'there'}!</h2>

            <p className="text-center mb-4">
                Enter your secure pin to find your images in this event.
            </p>

            {error && <div className="error-message text-center mb-3"><p>{error}</p></div>}

            <form onSubmit={handleSubmit}>
                <div className="pin-container">
                    {digits.map((digit, index) => (
                        <input
                            key={index}
                            ref={inputRefs[index]}
                            type="text"
                            inputMode="numeric"
                            className="pin-digit"
                            value={digit}
                            onChange={(e) => handleInputChange(index, e.target.value)}
                            onKeyDown={(e) => handleKeyDown(index, e)}
                            onPaste={index === 0 ? handlePaste : null}
                            maxLength={1}
                            required
                        />
                    ))}
                </div>

                <div className="text-center">
                    <button type="submit" className="button button-primary" disabled={loading}>
                        {loading ? <><i className="fa fa-spinner fa-spin"></i> Verifying...</> : 'Submit'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default PinVerification;